import useJobPoller from 'hooks/useJobPoller';
import { ThemeContext } from 'context/themes';
import { ThemeProvider } from '@mui/material/styles';
import TopBar from '../topNav/TopNavIndex';
import LeftBar from '../leftNav/LeftNavIndex';
import { CssBaseline } from '@mui/material';
import DashboardProviders from 'context/DashboardProviders';
import { ReactNode } from 'react';

type DefaultLayoutProps = {
  children?: any;
  pageContentOverride?: ReactNode;
  pageProps: {
    [key: string]: any;
  };
  showLeftBar?: boolean;
  hideTenantSwitcher?: boolean;
};

export function DashboardLayout({
  children,
  pageContentOverride = null,
  showLeftBar = true,
  hideTenantSwitcher = false,
}) {
  useJobPoller();

  return (
    <ThemeContext.Consumer>
      {(tContext) => {
        return (
          <ThemeProvider theme={tContext.lightTheme}>
            {pageContentOverride ?? (
              <>
                <CssBaseline enableColorScheme />
                <TopBar hideTenantSwitcher={hideTenantSwitcher} />
                <div className="left-nav-page-content-wrapper">
                  {showLeftBar && <LeftBar className="left-nav" />}
                  <div className="page-content-wrapper">{children}</div>
                </div>
              </>
            )}
          </ThemeProvider>
        );
      }}
    </ThemeContext.Consumer>
  );
}

export function DashboardLayoutWithProviders({
  children,
  pageProps,
  pageContentOverride,
  showLeftBar = true,
  hideTenantSwitcher = false,
}: DefaultLayoutProps) {
  return (
    <DashboardProviders pageProps={pageProps}>
      <DashboardLayout
        showLeftBar={showLeftBar}
        hideTenantSwitcher={hideTenantSwitcher}
        pageContentOverride={pageContentOverride}
      >
        {children}
      </DashboardLayout>
    </DashboardProviders>
  );
}
